/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Space_Auto_Embed_BlurbInputs */



/**
* | output |
* | --- |
* | "With auto-embed on, files are processed and made searchable as soon as they are uploaded, so they are ready for @-mentions in chats without any manual step." |
*
* @param {Uno_Edu_Space_Auto_Embed_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_space_auto_embed_blurb = /** @type {((inputs?: Uno_Edu_Space_Auto_Embed_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Space_Auto_Embed_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit aktivierter automatischer Einbettung werden Dateien verarbeitet und durchsuchbar gemacht, sobald sie hochgeladen werden, sodass sie ohne manuellen Schritt für @-Erwähnungen in Chats bereitstehen.")
	return /** @type {LocalizedString} */ ("With auto-embed on, files are processed and made searchable as soon as they are uploaded, so they are ready for @-mentions in chats without any manual step.")
});